module.exports = {
  ...require('./vocabulary'),
  ...require('./roomStyle'),
  ...require('./existingObjects'),
  ...require('./asFoundCheckpoint'),
  ...require('./inspectionLabels'),
  ...require('./inspectionPlan'),
  ...require('./inspectionReview'),
  ...require('./inspectionItems'),
  ...require('./inspectionViews'),
  ...require('./inspectionReport'),
  ...require('./inspectedDevices'),
  ...require('./floorFindings'),
};
